<template>
  <!-- 拣货单详情-->
  <div class="PickingInfo" v-loading="loading">
    <div class="PickingInfo__top">
      <el-descriptions :column="3">
        <el-descriptions-item label="系统单号">
          {{ pickingInfo.rsys }}
        </el-descriptions-item>
        <el-descriptions-item label="检索单号">
          {{ pickingInfo.sretrieval }}
        </el-descriptions-item>
        <el-descriptions-item label="订单号">
          {{ pickingInfo.rorder }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="2">
        <el-descriptions-item label="出货门店">
          {{ pickingInfo.sstore }}
        </el-descriptions-item>
        <el-descriptions-item label="门店地址">
          {{ pickingInfo.sstoreAddr }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="2">
        <el-descriptions-item label="顾客地址">
          {{ pickingInfo.ccustomerAddr }}
        </el-descriptions-item>
        <el-descriptions-item label="订单渠道">
            <el-select v-model="pickingInfo.rchannel" filterable placeholder="请选择" :disabled="true" size="mini">
              <el-option v-for="item in channelOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <div class="flex">
        <el-descriptions :column="2">
          <el-descriptions-item label="单据状态">
            待出货
          </el-descriptions-item>
          <el-descriptions-item label="单据备注">
            {{ pickingInfo.cremark }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="w200 flex" style="justify-content: flex-end">
          <el-button type="primary" size="mini" plain @click="deviceDialogVisible = true">门店智控</el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <el-descriptions :column="4">
        <el-descriptions-item label="制单人">
          {{ pickingInfo.screate }}
        </el-descriptions-item>
        <el-descriptions-item label="制单时间">
          {{ pickingInfo.tcreate | time }}
        </el-descriptions-item>
        <el-descriptions-item label="审核人">
          {{ pickingInfo.saudit }}
        </el-descriptions-item>
        <el-descriptions-item label="审核时间">
          {{ pickingInfo.taudit | time }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="h450">
      <el-table ref="multipleTable" :data="tableData"  height="450">
        <el-table-column label="标识" align="center" width="70" prop="lock">
          <template slot-scope="scope">
            <el-button v-if="scope.row.unlock" icon="el-icon-s-goods" circle @click="handleChangeUnlock(scope.$index, scope.row)"></el-button>
            <el-button v-else icon="el-icon-goods" circle @click="handleChangeUnlock(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column label="SKU" align="center" width="70" prop="csku" />
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w50 h50" :src="scope.row.cmasterUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="货品编码" align="center" width="130" prop="cbarcode" />
        <el-table-column label="货品名称" align="center" prop="sgoods" />
        <el-table-column label="单位" align="center" width="70" prop="sunit" />
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.nprice">￥ {{ scope.row.nprice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="库位" align="center" width="70" prop="zinventory" >
          <template #default="scope">
            <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces;">
              <el-link type="primary" @click="handleTakeoff(scope.row.rinventory)">{{ scope.row.zinventory }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" width="70">
          <template #default="scope">
            <span v-if="scope.row.nout > 1" style="color: red">{{ scope.row.nout }}</span>
            <span v-else>{{ scope.row.nout }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="red" @click="handleArriveEmptyDialog(scope.row.sid, scope.row.rplatformOrderDetail)">{{ scope.row.unlock ? "选取货品" : "到店无货" }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
      <div>
        共计 <span class="blue">{{ tableData.length }}种</span> 货品
      </div>
      <div>
        <el-button type="danger" plain @click="handleCancel">取消</el-button>
        <el-button type="success" plain @click="update">改单</el-button>
        <el-button type="primary" @click="shipment">出货</el-button>
      </div>
    </div>
    <el-dialog v-if="deviceDialogVisible" class="elDialog" :close-on-click-modal="false" title="查看门店智控" :visible.sync="deviceDialogVisible" width="400px" append-to-body>
      <deviceControl :store-info="storeInfo" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="到店无货" :visible.sync="changeOrderVisible" width="1000px" append-to-body>
      <changeOrder v-if="changeOrderVisible" :select-order-table-data="selectOrderTableData" :store-id="storeInfo.sid" @handleSubmit="handleChooseGiveGoods" @handleClose="handleClose" />
    </el-dialog>
  </div>
</template>
<script>
import { formatTime } from "@/utils/utils";
import deviceControl from "./deviceControl.vue";
import changeOrder from "@/views/order/dialog/changeOrder.vue";
import channel from "@/utils/channel.js";

export default {
  name: "PickingInfo",
  components: { deviceControl, changeOrder },
  filters: {
    time(value) {
      if (value === null || value === "" || value === undefined) {
        return "";
      } else {
        return formatTime(value);
      }
    },
  },
  props: {
    sid: {
      type: [String, Object, Array],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      pickingInfo: {},
      pickingDetail: {},
      tableData: [],
      storeInfo: {},
      selectOrderTableData: [],
      orderDetailList: [],
      // 智控弹窗
      deviceDialogVisible: false,
      changeOrderVisible: false,
      changeOrderTitle: false,
      channelOptions: channel,
      pdSid: "",
    };
  },
  created() {
    this.selectById();
  },
  methods: {
    handleChooseGiveGoods(goodsList) {
      if (goodsList.length !== 0) {
        this.changeOrderVisible = false;
        this.loading = true;
        this.topsAjax.post(`${this.baseUrls.ordPicking}/resetPicking`, { pickingId: this.sid, pickingDetailId: this.pdSid, goodsList }).then((res) => {
          this.loading = false;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.selectById();
        });
      } else {
        this.$message({
          message: "至少选择一个货品",
          type: "error",
        });
      }
    },
    handleTakeoff(inventoryId) {
      this.$confirm("对货品强制下架操作将不能再拣货，确认要强制下架？")
        .then((_) => {
          this.loading = true;
          let url = `${this.baseUrls.orderInventory}/offWarehouseById`;
          this.topsAjax.post(url, { sid: inventoryId }).then(() => {
            url = `${this.baseUrls.ordPicking}/change`;
            let params = { sid: this.sid };
            this.topsAjax.post(url, params).then((res) => {
              this.loading = false;
              this.$emit("handleUpdate", this.sid, this.pickingInfo.rorder);
            });
          });
        })
    },
    handleArriveEmptyDialog(pdSid, orderDetailId) {
      let arr = [];
      for (let i = 0; i < this.orderDetailList.length; i++) {
        if (this.orderDetailList[i].sid === orderDetailId) {
          arr.push(this.orderDetailList[i]);
        }
      }
      this.selectOrderTableData = arr;
      this.pdSid = pdSid;
      this.changeOrderVisible = true;
    },
    handleChangeUnlock(index, row) {
      row.unlock = !row.unlock;
      this.$set(this.tableData, index, { ...row })
    },
    // --------------------------------------------
    selectById() {
      this.loading = true;
      let params = { sid: this.sid };
      this.topsAjax.get(`${this.baseUrls.ordPicking}/selectById`, params).then((res) => {
        this.pickingInfo = res.picking;
        this.tableData = res.pickingDetailList;

        this.topsAjax.get(`${this.baseUrls.ordPicking}/selectOrderDetailById`, params).then((res) => {
          this.orderDetailList = res;
        });

        this.topsAjax.get(`${this.baseUrls.orderStore}/get/` + this.pickingInfo.rstore).then((res) => {
          this.loading = false;
          this.storeInfo = res;
        });
      });
    },
    //取消
    handleCancel() {
      this.$confirm("是否取消当前记录？")
        .then((_) => {
          this.loading = true;
          this.topsAjax.post(`${this.baseUrls.ordPicking}/cancelById`, { sid: this.sid }).then((res) => {
            this.loading = false;
            this.$message({
              message: "取消成功",
              type: "success",
            });
            this.handleClose();
          });
        })
        .catch((_) => {});
    },
    /**
     * 出货
     */
    shipment() {
      this.loading = true;
      let url = `${this.baseUrls.ordPicking}/shipment`;
      let params = { sid: this.sid };
      this.topsAjax.post(url, params).then((res) => {
        this.loading = false;
        this.$message({
          message: "出货成功",
          type: "success",
        });
        this.handleClose();
      });
    },
    /**
     * 改单
     */
    update() {
      this.loading = true;
      let url = `${this.baseUrls.ordPicking}/change`;
      let params = { sid: this.sid };
      this.topsAjax.post(url, params).then((res) => {
        this.loading = false;
        this.$emit("handleUpdate", this.sid, this.pickingInfo.rorder);
      }).catch((_) => {
        this.loading = false;
        this.$message({
          message: "改单失败，请联系管理员",
          type: "error",
        });
      });
    },
    /**
     * 取消
     */
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>
<style lang="scss" scoped>
:deep .discard-row4 {
  text-decoration: line-through;
}
.PickingInfo {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__top {
    .el-divider--horizontal {
      margin: 7px 0;
    }

    .el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
      padding-bottom: 5px;
    }

    .el-input--medium .el-input__inner {
      height: 20px;
      line-height: 20px;
    }

    .el-input__inner {
      border: 0px;
    }

    //隐藏图标
    .el-input__icon {
      display: none;
    }
  }
}
</style>
